document.addEventListener('alpine:init', () => {
  Alpine.data('ThemeSection_filterable', (section_id) => {
    return {
      focusId: '',
      filterData: [],
      _drawerScrollTop: null,
      _abort: null,
      init() {
        initTeleport(this.$root);

        Alpine.store('modals').register('filters', 'leftDrawer');

        window.addEventListener('popstate', this.onHistoryChange.bind(this));

        this._observeResultsMutations();
      },
      filterFormSubmit(e) {
        this.focusId = e.target.id;
        // Keep the mobile filter drawer open and remember its scroll position so
        // the live facet re-render doesn't jump the user back to the top.
        const drawerSlot = document.getElementById('left-drawer-slot');
        this._drawerScrollTop = drawerSlot ? drawerSlot.scrollTop : 0;
        let form = e.target.form;
        if (e.target.tagName.toLowerCase() === 'form') {
          form = e.target;
        }
        const formData = new FormData(form);
        const searchParams = new URLSearchParams(formData);
        searchParams.delete('price_range');
        this.renderPage(searchParams.toString(), e);
      },
      clearAllFilters(e) {
        const drawerSlot = document.getElementById('left-drawer-slot');
        this._drawerScrollTop = drawerSlot ? drawerSlot.scrollTop : 0;
        this.renderPage(new URL(e.currentTarget.href).searchParams.toString());
      },
      renderPage(searchParams, event, updateURLHash = true) {
        // Cancel any in-flight fetch so the latest user action always wins,
        // even when this render is served from cache.
        if (this._abort) this._abort.abort();
        document.getElementById('facets-results').classList.add('opacity-50');
        const url = `${window.location.pathname}?section_id=${section_id}&${searchParams}`;
        const filterDataUrl = (element) => element.url === url;
        this.filterData.some(filterDataUrl)
          ? this.renderFromCache(filterDataUrl, event)
          : this.renderFromFetch(url, event);
        if (updateURLHash) this.updateURLHash(searchParams);
      },
      async renderFromFetch(url, event) {
        this._abort = new AbortController();
        let html;
        try {
          const response = await fetch(url, { signal: this._abort.signal });
          html = await response.text();
        } catch (error) {
          // A newer request superseded this one — it now owns the UI.
          if (error.name === 'AbortError') return;
          this.handleFilterError(error);
          return;
        }
        this.filterData = [...this.filterData, { html, url }];
        // Render outside the try/catch so a genuine markup/parse bug propagates
        // and stays observable, rather than being masked as a transport error.
        this.renderMarkup(html);
      },
      handleFilterError(error) {
        console.error('[filterable] filter request failed', error);
        document.getElementById('facets-results').classList.remove('opacity-50');
        this._drawerScrollTop = null;
        liveRegion(
          (window.theme &&
            window.theme.strings &&
            window.theme.strings.filterError) ||
            'Something went wrong. Please try again.',
          true
        );
      },
      renderFromCache(filterDataUrl, event) {
        const html = this.filterData.find(filterDataUrl).html;
        this.renderMarkup(html);
      },
      renderMarkup(html) {
        const parsed = new DOMParser().parseFromString(html, 'text/html');
        const newFilterable = parsed.getElementById('facets-filterable');
        if (!newFilterable) {
          // Response didn't contain the expected section (error page, redirect,
          // bot challenge…). Recover gracefully on both fetch and cache paths.
          this.handleFilterError(
            new Error('Missing #facets-filterable in response')
          );
          return;
        }
        const innerHTML = newFilterable.innerHTML;
        const filterableEl = document.getElementById('facets-filterable');

        if (innerHTML !== filterableEl.innerHTML) {
          filterableEl.closest('.shopify-section').dispatchEvent(
            new CustomEvent('cascade:section:willmutate', {
              bubbles: true,
            })
          );

          setTimeout(() => {
            filterableEl.querySelectorAll('[x-teleport]').forEach((el) => {
              el.remove();
            });

            filterableEl.innerHTML = innerHTML;

            this.$nextTick(() => {
              initTeleport(filterableEl);
              this.restoreDrawerScroll();
            });
          }, 300);
        } else {
          document
            .getElementById('facets-results')
            .classList.remove('opacity-50');
          this.restoreDrawerScroll();
        }

        const count = parsed.getElementById('facets-results-count').innerHTML;
        liveRegion(count);

        if (this.focusId) {
          setTimeout(() => {
            // Re-query: the toggled input may have been re-created (or removed,
            // e.g. a now-disabled zero-count facet) by the re-render.
            // preventScroll so refocusing doesn't fight the drawer scroll restore.
            const el = document.getElementById(this.focusId);
            if (el) el.focus({ preventScroll: true });
          }, 50);
        }
      },
      restoreDrawerScroll() {
        const drawerSlot = document.getElementById('left-drawer-slot');
        // == null so a saved scroll of exactly 0 still restores; null means
        // nothing was saved (e.g. the popstate/back-forward path).
        if (!drawerSlot || this._drawerScrollTop == null) return;
        // Wait one frame so Alpine has finished re-teleporting the filter form
        // into the drawer before we restore the scroll offset.
        requestAnimationFrame(() => {
          drawerSlot.scrollTop = this._drawerScrollTop;
          this._drawerScrollTop = null;
        });
      },
      updateURLHash(searchParams) {
        history.pushState(
          { searchParams },
          '',
          `${window.location.pathname}${
            searchParams && '?'.concat(searchParams)
          }`
        );
      },
      onHistoryChange(event) {
        const searchParams = event.state.searchParams || '';
        this.renderPage(searchParams, null, false);
      },
      _observeResultsMutations() {
        const containerEl = document.getElementById('facets-filterable');

        const mutationObserverOptions = {
          childList: true,
          attributes: false,
          // Omit (or set to false) to observe only changes to the parent node
          subtree: false,
        };

        const callback = (mutationList, observer) => {
          mutationList.forEach((mutation) => {
            if (mutation.type === 'childList') {
              mutation.target.closest('.shopify-section').dispatchEvent(
                new CustomEvent('cascade:section:hasmutated', {
                  bubbles: true,
                })
              );
            }
          });
        };

        const mutationObserver = new MutationObserver(callback);
        mutationObserver.observe(containerEl, mutationObserverOptions);
      },
    };
  });
});
